import moment from "moment";

export const transformValueFloattoFormated = (value, casas = 2) => {

    let valor = value.toFixed(casas).toString();
    if (!valor)
        valor = "0";

    valor = valor.replace(".", ",");

    return valor;
}

export const formatarValorMonetario = (valor) => valor == null ? "" : `R$ ${transformValueFloattoFormated(valor)}`;

export const formatarPeriodo = (dataInicial, dataFinal) => {
    const inicioValido = dataInicial && moment(dataInicial).isValid();
    const fimValido = dataFinal && moment(dataFinal).isValid();

    if (!inicioValido && !fimValido)
        return "Não informado";

    const inicio = inicioValido ? moment(dataInicial).format("DD/MM/YYYY") : "";
    const fim = fimValido ? moment(dataFinal).format("DD/MM/YYYY") : "";

    return `${inicio} à ${fim}`;
}
